export default __webpack_public_path__ + "static/Entenda0111-c78fb78c370f3a41be9e897274210216.jpg";